<template>
  <span>{{ format(price) }}</span>
</template>
<script>
export default {
  name: 'Price',
  props: {
    price: null,
    currency: {
      default: 'PLN',
      type: String
    }
  },
  methods: {
    format(price) {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: this.currency}).format(price);
    }
  }
}
</script>